<template>
  <div
    class="ui-logo-footer"
    data-test="logo-footer"
  >
    <slot />
    <a
      class="ui-logo-footer__link"
      :href="`https://www.sendcloud.com${fullUtmString}`"
      target="_blank"
      rel="noopener"
      data-test="logo-footer-anchor"
    >
      <UiLogo logo-color="#999" />
    </a>
  </div>
</template>

<script>
import UiLogo from '../UiLogo/UiLogo.vue'
export default {
  name: 'UiPromoFooter',

  components: {
    UiLogo,
  },

  props: {
    utmString: {
      type: String,
      required: false,
      default: '',
    },
  },

  computed: {
    fullUtmString() {
      return this.utmString ? `?${this.utmString}` : ''
    },
  },
}
</script>

<style lang="scss">
.ui-logo-footer {
  align-items: center;
  color: #999; /* TODO: define as variable? */
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  font-family: 'Source Sans Pro', Arial, sans-serif;
  font-size: 14px;
  justify-content: center;
}

.ui-logo-footer__link {
  color: inherit;
  margin-left: 10px;
  text-decoration: none;
  width: 125px;

  &:focus {
    border-radius: 999px;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
    outline: 0;
  }

  &:hover {
    text-decoration: underline;
  }
}
</style>
